<template>
  <div class="record">
    <Swipe ref="swipeRef" :show-indicators="false" :loop="false">
      <SwipeItem style="height: auto">
        <div class="record-right">
          <div class="record-right-item">
            <div class="record-right-item-step" style="width: 1.6rem"></div>

            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                font-weight: bold;
              "
            >
              <div>1分</div>
              <div>10分</div>
            </div>
          </div>
          <template v-for="(item, index) in gameList">
            <div class="record-right-item" :key="index">
              <!-- <Checkbox
                    :icon-size="12"
                    class="record-right-item-check"
                    v-model="item.checked"
                    shape="square"
                    :checked-color="item.color"
                    @click="checkHandle(item)"
                    >{{ item.name }}</Checkbox
                  > -->
              <div class="record-right-item-check">
                {{ item.name }}
              </div>
              <Slider
                :button-size="12"
                class="record-right-item-step"
                v-model="item.value"
                :step="1"
                :max="10"
                :min="0"
                :active-color="item.color"
                disabled
              />
              <div class="record-right-item-value">
                {{ item.value }}
              </div>
            </div>
          </template>

          <NfButton
            color="rgb(172,185,233)"
            round=".5rem"
            style="margin-top: 0.2rem"
            class="card-select-btns-btn"
            @click.native="changeSwiper(1)"
            >查看轮盘</NfButton
          >
        </div>
      </SwipeItem>
      <SwipeItem>
        <div class="record-left" style="pointer-events: none">
          <MorebarEchart
            @click.stop
            :distData="gameList"
            :width="width"
            :height="height"
          />
        </div>
        <NfButton
          color="rgb(172,185,233)"
          round=".5rem"
          style="margin-top: 0.2rem; padding: 0 0.2rem"
          class="card-select-btns-btn"
          @click.native="changeSwiper(0)"
          >查看打分</NfButton
        >
      </SwipeItem>
    </Swipe>
  </div>
</template>

<script>
import { Slider, Swipe, SwipeItem } from "vant";
import { MorebarEchart } from "@/components/echarts";
import NfButton from "@/components/game-ui/NfButton.vue";
export default {
  components: { Slider, MorebarEchart, Swipe, SwipeItem, NfButton },
  data() {
    return {
      gameList: [
        {
          name: "同伴",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(255, 129, 129)",
          borderColor: "rgba(255, 129, 129)",
        },
        {
          name: "异性",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(255, 195, 125)",
          borderColor: "rgba(255, 195, 125, 2)",
        },
        {
          name: "老师",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(92, 211, 231)",
          borderColor: "rgba(92, 211, 231)",
        },
        {
          name: "学习",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(255, 215, 39)",
          borderColor: "rgba(255, 215, 39)",
        },
        {
          name: "自我",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(97, 216, 81)",
          borderColor: "rgba(97, 216, 81)",
        },
        {
          name: "兴趣",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(193, 169, 253)",
          borderColor: "rgba(193, 169, 253)",
        },
        {
          name: "娱乐",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(230, 118, 247)",
          borderColor: "rgba(230, 118, 247)",
        },
        {
          name: "家庭",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(110, 144, 255)",
          borderColor: "rgba(110, 144, 255)",
        },
        {
          name: "偶像",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(93, 193, 156)",
          borderColor: "rgba(93, 193, 156)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(255, 129, 129)",
          borderColor: "rgba(255, 129, 129)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(155, 109, 129)",
          borderColor: "rgba(155, 109, 129)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(55, 129, 119)",
          borderColor: "rgba(55, 129, 119)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(155, 29, 129)",
          borderColor: "rgba(155, 29, 129)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(5, 129, 19)",
          borderColor: "rgba(5, 129, 129)",
        },
      ],
    };
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    width: {
      type: String,
      default: "300px",
    },
    height: {
      type: String,
      default: "300px",
    },
  },
  watch: {
    value: {
      handler(val) {
        console.log(val, "valvalvalvalvalval ");
        // this.gameList = val;
        // 将value的值依次合并给gameList
        this.gameList.splice(val.length, this.gameList.length - val.length);

        // 切割
        this.gameList.map((item, index) => {
          this.gameList[index] = {
            ...item,
            ...val[index],
            value: val[index].score || 0,
            name: val[index].cardName || "",
            color: val[index].colour || this.gameList[index].color,
          };
          // item.name = (val[index] || {}).cardName || "";
        });
        // this.gameList.splice(val.length);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    changeSwiper(index) {
      this.$refs.swipeRef.swipeTo(index);
    },
  },
};
</script>

<style scoped lang="scss">
.record {
  &-left {
    padding: 0 0.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &-right {
    padding: 0 0.2rem;
    font-size: 0.2rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    &-item {
      display: flex;
      align-items: center;
      &-check {
        flex-shrink: 0;
        margin-right: 0.4rem;
      }
      &-value {
        flex-shrink: 0;
        // padding: 0 0.05rem;
        padding-left: 0.3rem;
      }
    }
  }
}
</style>
